import React from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { PersonIcon } from '../../Icon';
import { getKey } from '../../GenerateKey';
import Chip from '@material-ui/core/Chip';

function getSteps(signersList) {
    const OrderOne = []; const OrderTwo = [];
    const OrderThree = []; const OrderFour = [];
    const OrderFive = [];
    signersList.map(signer => {
        if (signer.signingOrder === 1) {
            OrderOne.push(signer)
        } else if (signer.signingOrder === 2) {
            OrderTwo.push(signer)
        } else if (signer.signingOrder === 3) {
            OrderThree.push(signer)
        } else if (signer.signingOrder === 4) {
            OrderFour.push(signer)
        } else if (signer.signingOrder === 5) {
            OrderFive.push(signer)
        }
    })
    return [OrderOne, OrderTwo, OrderThree, OrderFour, OrderFive];
}

const statusColours = {
    created: '#666666',
    sent: '#ffc107',
    declined: '#c21020',
    completed: '#367c2b',
    review: '#666666'
}

function getSignerChip(signer) {
    return (
        <span key={'ord-' + getKey() + getKey()}>
            <Chip className="mb-1"
                label={signer.name}
                size="medium" style={{ color: '#ffffff', 'backgroundColor': signer.status ? statusColours[signer.status] : statusColours['review'] }} />
            <br />
        </span>)
}

export default function ThirdPartyStepper({ signersList, bgColor }) {
    const steps = getSteps(signersList);


    return (
        <Stepper alternativeLabel className="mw-100 border rounded" style={{ 'backgroundColor': bgColor }} >
            {steps.filter(step => step.length > 0).map((signers) => (
                <Step active={true} key={'sign-' + getKey() + getKey()}>
                    <StepLabel icon={<PersonIcon />}>
                        {signers.map(signer => getSignerChip(signer))}
                    </StepLabel>

                </Step>
            ))}
        </Stepper>
    );
}
